import React from 'react'
import { Link } from 'react-router-dom'

export const Footer = () => {
    return (
        <footer>
            <div className="footer-upper">

                <div id='footer-logo-container'>
                    <img id='footer-logo' src='images/logo-2.png' alt='alpha builders logo' />
                    <div>
                        <h2 className='brass-text-gradient'>ALPHA</h2>
                        <div id='f-l-line'></div>
                        <h3 className='brass-text-gradient'>BUILDERS</h3>
                    </div>

                </div>

                <div>

                    <div className="footer-info-card">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78.71 110" className="location-icon">
                            <defs>
                                <style>
                                    {
                                        `
                                                  .a {
                                        fill: #fff;
                                }
                                        `
                                    }

                                </style>
                            </defs>
                            <path className="a"
                                d="M252.15,328c-30.6,0-49.45,33.39-33.65,59.56l28.68,47.64a5.8,5.8,0,0,0,5,2.8,5.87,5.87,0,0,0,5-2.8l28.67-47.64a38.91,38.91,0,0,0,5.71-20.21C291.5,346.89,275.12,328,252.15,328Zm0,62.88a22,22,0,1,1,21.94-21.94A22,22,0,0,1,252.15,390.88Z"
                                transform="translate(-212.79 -328)" />
                        </svg>
                        <p>3709 Jones Ave Ne, Renton WA</p>
                    </div>


                    <div className="footer-info-card">
                        <a className='fic-link' href='tel:425-260-9444' target='_blank'>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 145.21 144.83" className="phone-icon">
                                <defs>
                                    <style>

                                        {
                                            `
                                             .a {
                                        fill: #fff;
                                }

                                        `
                                        }

                                    </style>
                                </defs>
                                <path className="a"
                                    d="M298.77,433.58l-6,6c-13.3,13.3-33.31,14.1-49.84,5.13-35-19-61.9-45.31-80.14-79.38-8.84-16.53-8-36.46,5.22-49.71l6.41-6.41a11.61,11.61,0,0,1,16.41,0l21.27,21.27a11.61,11.61,0,0,1,0,16.41l-12.49,12.49a6.87,6.87,0,0,0-.62,9A209,209,0,0,0,239.6,409a6.87,6.87,0,0,0,9-.63l12.5-12.5a11.62,11.62,0,0,1,16.42,0l21.26,21.27A11.62,11.62,0,0,1,298.77,433.58Z"
                                    transform="translate(-156.96 -305.82)" />
                            </svg>
                            <p>425-260-9444</p>
                        </a>
                    </div>




                    <div className="footer-info-card">
                        <a className='fic-link' href='mailto:Michael@alphabuilders-wa.com' target='_blank'>
                            <svg className="email-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 161.78 99.01">
                                <defs>
                                    <style>

                                        {

                                            `
                                                     .a {
                                        fill: #fff;
                                }

                                    .a,
                                    .b {
                                        stroke: #943a00;
                                    stroke-miterlimit: 10;
                                    stroke-width: 3px;
                                }

                                    .b {
                                        fill: none;
                                }
                                        `
                                        }



                                    </style>
                                </defs>
                                <rect className="a" x="1.5" y="1.5" width="158.78" height="96.01" />
                                <polyline className="b" points="1.5 1.5 80.89 49.51 160.28 1.5" />
                                <polyline className="b" points="1.5 97.52 67.95 41.68 80.89 49.51 93.83 41.68 160.28 97.52" />
                            </svg>
                            <p>Michael@alphabuilders-wa.com</p>
                        </a>
                    </div>





                    <div className="footer-info-card">
                        <svg className="license-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 209.18 136.37">
                            <defs>
                                <style>

                                    {
                                        `
        .a {
                                        fill: #fff;
                                    stroke-width: 2.89px;
                                }

                                    .a,
                                    .b {
                                        stroke: #943a00;
                                    stroke-miterlimit: 10;
                                }

                                    .b {
                                        fill: none;
                                    stroke-width: 2.25px;
                                }

                                    .c {
                                        fill: #943a00;
                                }

                                        `
                                    }

                                </style>
                            </defs>
                            <rect className="a" x="1.44" y="1.44" width="206.29" height="133.48" />
                            <path className="b" d="M186.15,190a36.89,36.89,0,1,1-36.88-36.89A36.77,36.77,0,0,1,186.15,190Z"
                                transform="translate(-94.23 -142.97)" />
                            <circle className="c" cx="55.03" cy="44.32" r="15.06" />
                            <path className="c" d="M174.18,217.24a36.88,36.88,0,0,1-49.83,0,27,27,0,0,1,49.83,0Z"
                                transform="translate(-94.23 -142.97)" />
                            <rect className="c" x="117.94" y="29.26" width="73.62" height="15.06" />
                            <rect className="c" x="117.94" y="70.79" width="73.62" height="13.17" />
                            <rect className="c" x="30.12" y="108.23" width="161.44" height="16.18" />
                        </svg>
                        <p>Lic#: ALPHABW762N2</p>
                    </div>

                </div>


                <div className="quick-links">
                    <h3>Quick Links</h3>
                    <ul>
                        <li><Link className='ql-link' to="/">Home</Link></li>
                        <li><Link className='ql-link' to="/about">About</Link></li>
                        <li><Link className='ql-link' to="/portfolio">Portfolio</Link></li>
                        <li><Link className='ql-link' to="/contact">Contact</Link></li>
                        <li><Link className='ql-link' to="/services">Services</Link></li>
                    </ul>
                </div>








            </div>

            <div className="footer-lower">
                <div className="footer-lower-line"></div>
                <a href='https://www.facebook.com/profile.php?id=61566555421586' target='_blank'>
                    <i className="fa fa-facebook footer-icon"></i>
                </a>

                <div className="footer-lower-line"></div>
            </div>

            <div className="footer-trademark">
                <span>&copy; Alpha Builders 2024 All Rights Reserved</span>

                <div id='privacy-links'>
                    <a className='priv-link' href='https://alphabuilders-wa.com/privacy'>Privacy Policy</a>
                    <div id="privacy-link-line"></div>
                    <a className='priv-link' href='https://alphabuilders-wa.com/terms'>Terms and Conditions</a>
                </div>
            </div>

        </footer>
    )
}
